import { SessionStorage } from 'client/javascript/storage';

export const USER_ID = 'user';
const DEFAULT_VALUE = {};

export default class User {
  static get() {
    return JSON.parse(SessionStorage.getItem(USER_ID)) || DEFAULT_VALUE;
  }

  static getValue(key) {
    return this.get()[key];
  }

  static saveValue(key, value) {
    const user = this.get();
    user[key] = value;
    SessionStorage.setItem(USER_ID, JSON.stringify(user));
  }

  static saveValues(keyValueMap) {
    const user = { ...this.get(), ...keyValueMap };
    SessionStorage.setItem(USER_ID, JSON.stringify(user));
  }

  static reset() {
    SessionStorage.setItem(USER_ID, JSON.stringify(DEFAULT_VALUE));
  }
}
